module.exports = __webpack_public_path__ + "media/promo/advent/images/tree-top-40a7e18134b514aef6ccb142afa5aacd.png";